import * as React from "react";

const AusCart: React.FC = () => {
    return (
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 498.94 444.44">
            <path
                d="M.62,77.59V37.76H113.83c11,3.9,16.51,11.82,18,23.26.95,7.23,3.72,14.28,4.17,21.51.59,9.64,5.1,11.55,14,11.53,107.61-.3,215.21,0,322.81-.4,12.65,0,21.55,3.73,26.73,15.38v10.48a9.74,9.74,0,0,0-1.58,2.63q-19.14,84.56-38.16,169.14c-4.38,19.57-9.24,23.76-29.06,23.76h-247c2.16,10.52,3.94,19.22,5.84,28.46h92.91c45.75,0,91.49-.08,137.24.05,16.51.05,25.33,10.93,22,26.46-1.38,6.41-2.7,12.84-4,19.12,3.35,2.46,6.23,4.4,8.92,6.58,26.38,21.47,23.08,62.91-6.48,79.7-5,2.86-10.71,4.55-16.09,6.78H409.42a40,40,0,0,0-4.7-2C384,474.41,370.64,459.1,368.3,438c-1.62-14.52,4.05-27,12.86-39H201.88c2.26,3.16,3.89,5.28,5.35,7.51,16.15,24.7,6.44,58.8-20.21,70.83-4,1.82-8.26,3.2-12.4,4.79H160c-2.59-.91-5.15-1.86-7.76-2.7-35-11.33-45.7-56.6-18.15-80.9,8.34-7.35,7.85-13.35,6-22.21C124.05,299,108.39,221.48,92.57,144c-3.46-16.9-7.14-33.75-10.78-50.87-19.1,0-36.9-.49-54.67.16C14.44,93.78,5.49,89.53.62,77.59Z"
                transform="translate(-0.62 -37.76)"
                fill="#000000"
            />
        </svg>
    );
};

export default React.memo(AusCart);
